import { c as _c } from "react/compiler-runtime";
import React, { useContext } from 'react';
import { useAtom } from 'jotai';
import { NUMBER_OF_SWATCHES_TO_SHOW } from 'commons/constants';
import useMobileColumnCount from 'components/consumer/ProductListingPage/state/mobileColumnCount/useMobileColumnCount';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
import { createSearchProductClickHandler } from 'components/consumer/consumer-search/algolia-insights-helpers/createSearchProductClickHandler';
import lastInsightsClickAtom from 'components/consumer/consumer-search/advanced-search/atoms/lastInsightsClickAtom';
import ShowroomDisplayContext from 'components/consumer/category-page-algolia/hooks/ShowroomDisplayContext';
const AdvancedSearchProductsGrid = t0 => {
  const $ = _c(7);
  const {
    products
  } = t0;
  const mobileColumnCount = useMobileColumnCount();
  const [, setLastInsightsClick] = useAtom(lastInsightsClickAtom);
  const showroomData = useContext(ShowroomDisplayContext);
  let t1;
  if ($[0] !== products || $[1] !== setLastInsightsClick || $[2] !== showroomData) {
    t1 = !!products && products?.length > 0 && products?.map((t2, index) => {
      const {
        campaign,
        id,
        isClearance,
        isFavorited,
        isHidden,
        label,
        meta,
        name,
        onDisplayInShowroomSlug,
        path,
        position,
        productFamily,
        productLabel,
        productType,
        quickship,
        secondaryImage,
        secondaryImageCropData,
        slug,
        variants,
        variantsToShow,
        variantsTotal,
        moreVariantsCount,
        bypass_stock,
        algoliaMetaData: t3
      } = t2;
      const algoliaMetaData = t3 === undefined ? {} : t3;
      return <ProductCardStatic key={`advanced-search-product-${id}-${variantsToShow?.[0]?.sku ?? variants?.[0]?.sku ?? ""}`} campaign={campaign} enableMobileCarousel={true} hidden={isHidden} id={id} isClearance={isClearance} isFavorited={isFavorited} label={label} layout="full" moreVariantsCount={moreVariantsCount ?? variantsTotal - (variantsToShow?.length ?? 0)} name={name} onDisplayInShowroomSlug={onDisplayInShowroomSlug || (showroomData?.productsOnDisplay?.includes(id) ? showroomData.slug : undefined)} path={path} position={position} productFamily={productFamily} productLabel={productLabel} productType={productType} quickship={quickship} secondaryImage={`${secondaryImage}`} secondaryImageCropData={secondaryImageCropData} slug={slug} variants={variants} variantsToShow={variantsToShow?.map(_temp) ?? variants?.slice(0, NUMBER_OF_SWATCHES_TO_SHOW).map(_temp2) ?? []} variantsTotal={variantsTotal} meta={meta} bypass_stock={bypass_stock} onClick={createSearchProductClickHandler(algoliaMetaData, setLastInsightsClick, {
        index,
        productId: id
      })} />;
    });
    $[0] = products;
    $[1] = setLastInsightsClick;
    $[2] = showroomData;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== mobileColumnCount || $[5] !== t1) {
    t2 = <div className="md:space-y-8 md:mb-8 md:flex-1 min-h-[400px]"><ProductCardGridUI limitWidth={false} columnsOnDesktop="auto" columnsOnMobile={mobileColumnCount}>{t1}</ProductCardGridUI></div>;
    $[4] = mobileColumnCount;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default AdvancedSearchProductsGrid;
function _temp(variant_0) {
  return {
    ...variant_0,
    image: `${variant_0?.image}`
  };
}
function _temp2(variant) {
  return {
    ...variant,
    image: `${variant?.image}`
  };
}